export enum SystemsEngineerEventName {
  UserEntersSystemsEngineerDashboard = 'userEntersSystemsEngineerDashboard'
}

export type SystemsEngineerEvent = {
  name: SystemsEngineerEventName.UserEntersSystemsEngineerDashboard
}
